module.exports = __webpack_public_path__ + "img/paypal.7177b8b5.png";